// Translation file version for cache busting
const TRANSLATION_VERSION = '2024-11-08-v2';
console.log('📦 [en.ts] Loading translation file - Version:', TRANSLATION_VERSION);

export default {
  // General
  appName: 'Admin Portal',
  login: 'Login',
  logout: 'Logout',
  email: 'Email',
  password: 'Password',
  forgotPassword: 'Forgot password?',
  rememberMe: 'Remember me',
  welcome: 'Welcome back',
  welcomeMessage: 'Sign in to continue to your Admin Portal',
  profile: 'Profile',
  help: 'Help',
  close: 'Close',
  retry: 'Retry',
  pleaseTryAgain: 'Please try again',
  errorLoadingData: 'Error loading data',
  noDataAvailable: 'No data available',
  technicalIssue: 'Technical issue occurred',
  networkError: 'Network connection failed. Please check your internet connection.',
  authExpired: 'Your session has expired. Please login again.',
  serverError: 'Server error. Please try again later.',
  prayerNotFound: 'Prayer not found.',
  backToList: 'Back to List',
  
  // Error Boundary
  systemError: 'System Error',
  networkErrorChip: 'Network Error',
  somethingWentWrong: 'Something Went Wrong',
  connectionFailed: 'Connection Failed',
  unexpectedError: 'The application encountered an unexpected error. Please reload the page',
  checkInternetConnection: 'Please check your internet connection and try again',
  reloadPage: 'Reload Page',
  tryAgain: 'Try Again',
  home: 'Home',
  technicalDetails: 'Technical Details',
  
  // User Profile
  userDetails: 'User Details',
  viewAndManageYourProfile: 'View and manage your profile information',
  editProfile: 'Edit Profile',
  contactInformation: 'Contact Information',
  accountInformation: 'Account Information',
  phone: 'Phone',
  bio: 'Bio',
  userId: 'User ID',
  accountCreated: 'Account Created',
  lastLogin: 'Last Login',
  memberSince: 'Member Since',
  errorLoadingProfile: 'Error loading profile. Please try again.',
  never: 'Never',
  invalidDate: 'Invalid Date',
  
  // User Roles
  superuser: 'Super User',
  admin: 'Admin',
  editor: 'Editor',
  viewer: 'Viewer',
  user: 'User',
  
  // User Actions
  confirmDelete: 'Are you sure you want to delete',
  userDeletedSuccessfully: 'User deleted successfully',
  errorDeletingUser: 'Error deleting user',
  errorTogglingStatus: 'Error toggling user status',
  userCreatedSuccessfully: 'User created successfully',
  errorCreatingUser: 'Error creating user',
  passwordsDoNotMatch: 'Passwords do not match',
  passwordMinLength: 'Password must be at least 8 characters',
  usernameIsRequired: 'Username is required',
  firstName: 'First Name',
  lastName: 'Last Name',
  enterFirstName: 'Enter first name',
  enterLastName: 'Enter last name',
  viewUserProfileDetails: 'View user profile and details',
  updateUserInformation: 'Update user information',
  enterName: 'Enter name',
  enterUsername: 'Enter username',
  selectRole: 'Select role',
  roleAutoCalculated: 'User role is automatically calculated based on permission groups (superuser → admin → user)',
  addNewUserToSystem: 'Add a new user to the system',
  confirmYourPassword: 'Confirm your password',
  enterPassword: 'Enter password',
  newPassword: 'New password',
  enterNewPassword: 'Enter new password',
  passwordsRequired: 'Password fields are required',
  passwordResetSuccessfully: 'Password reset successfully',
  errorResettingPassword: 'Error resetting password',
  userUpdatedSuccessfully: 'User updated successfully',
  errorUpdatingUser: 'Error updating user',
  backToUsers: 'Back to users',
  userNotFound: 'User not found',
  permissionsUpdatedSuccessfully: 'Permissions updated successfully',
  errorUpdatingPermissions: 'Error updating permissions',
  usernameAutoGeneratedFromEmail: 'If left empty, username will be generated from email',
  
  // Sidebar Menu
  dashboard: 'Dashboard',
  users: 'Users & Permissions',
  technicalSupport: 'Technical Support',
  settings: 'General Settings',
  generalSettings: 'General',
  languages: 'Languages',
  statistics: 'Statistics',
  management: 'Management',
  
  // Languages
  code: 'Code',
  languagesTable: 'Languages Table',
  noLanguagesFound: 'No languages found',
  searchLanguages: 'Search languages by code or name',
  activateLanguage: 'Activate Language',
  deactivateLanguage: 'Deactivate Language',
  confirmActivateLanguage: 'Are you sure you want to activate {{name}}?',
  confirmDeactivateLanguage: 'Are you sure you want to deactivate {{name}}?',
  activate: 'Activate',
  deactivate: 'Deactivate',
  all: 'All',
  active: 'Active',
  inactive: 'Inactive',
  status: 'Status',
  
  // Portal Sections
  portalSections: 'Portal Sections',
  imamIntro: "Imam's Biography",
  hadiths: 'Hadiths',
  specialFiles: 'Special Files',
  prayers: 'Prayers & Visitations',

  // Special Files
  createSpecialFile: 'Create Special File',
  editSpecialFile: 'Edit Special File',
  createSpecialFileDescription: 'Create a new special file with custom content',
  editSpecialFileDescription: 'Edit special file information and content',
  addSpecialFile: 'Add Special File',
  specialFilesTable: 'Special Files Table',
  noSpecialFilesFound: 'No special files found',
  itemsSelected: 'items selected',
  selectedItems: 'Selected Items',
  availableItems: 'Available Items',
  noItemsFound: 'No items found',
  noItemsAvailable: 'No items available',
  searchBooks: 'Search books...',
  searchMedia: 'Search media...',
  searchArticles: 'Search articles...',
  noBooksAvailable: 'No books available',
  noMediaAvailable: 'No media available',
  noArticlesAvailable: 'No articles available',
  sectionTitle: 'Section Title',
  sectionDescription: 'Section Description',
  enterBookSectionTitle: 'e.g., Related Books',
  enterBookSectionDescription: 'Enter book section description',
  enterMultimediaSectionTitle: 'e.g., Videos & Images',
  enterMultimediaSectionDescription: 'Enter multimedia section description',
  enterArticleSectionTitle: 'e.g., Related Articles',
  enterArticleSectionDescription: 'Enter article section description',
  selectedBooks: 'Selected Books',
  selectedMedia: 'Selected Media',
  selectedArticles: 'Selected Articles',
  selectBooks: 'Select Books',
  selectMedia: 'Select Media',
  selectArticles: 'Select Articles',
  booksSection: 'Books Section',
  multimediaSection: 'Multimedia Section',
  articlesSection: 'Articles Section',
  noTopicsAdded: 'No topics added yet',
  confirm: 'Confirm',
  image: 'Image',
  bookSectionTitle: 'Book Section Title',
  bookSectionDescription: 'Book Section Description',
  multimediaSectionTitle: 'Multimedia Section Title',
  multimediaSectionDescription: 'Multimedia Section Description',
  articleSectionTitle: 'Article Section Title',
  articleSectionDescription: 'Article Section Description',
  multimediaItems: 'Multimedia Items',
  media: 'Media',
  published: 'Published',
  unpublished: 'Unpublished',
  draft: 'Draft',

  // Prayer Sub-sections
  prayerCategories: 'Prayer Categories',
  loadingCategories: 'Loading categories...',
  selected: 'Selected',
  selectedCategories: 'Selected Categories',
  addCategory: 'Add Category',
  viewCategoryPrayers: 'View prayers in this category',
  clickToViewPrayers: 'Click to view',
  fromSubcategories: 'From subcategories',
  categoryCreatedSuccessfully: 'Category created successfully',
  categoryUpdatedSuccessfully: 'Category updated successfully',
  categoryDeletedSuccessfully: 'Category deleted successfully',
  categoryOrderUpdatedSuccessfully: 'Category order updated successfully',
  errorCreatingCategory: 'Error creating category',
  errorUpdatingCategory: 'Error updating category',
  errorDeletingCategory: 'Error deleting category',
  errorUpdatingCategoryOrder: 'Error updating category order',
  prayerCreatedSuccessfully: 'Prayer created successfully',
  prayerUpdatedSuccessfully: 'Prayer updated successfully',
  prayerDeletedSuccessfully: 'Prayer deleted successfully',
  errorCreatingPrayer: 'Error creating prayer',
  errorUpdatingPrayer: 'Error updating prayer',
  errorDeletingPrayer: 'Error deleting prayer',
  showing: 'Showing',
  of: 'of',
  audio: 'Audio',
  withAudio: 'With Audio',
  withoutAudio: 'Without Audio',
  available: 'Available',
  notAvailable: 'Not Available',
  updatedAt: 'Updated At',
  prayerReciters: 'Prayer Reciters',
  prayerReferences: 'Prayer References',
  prayerParts: 'Prayer Parts',

  // Prayer Actions
  addPrayer: 'Add Prayer',
  addPrayerPart: 'Add Prayer Part',
  addReciter: 'Add Reciter',
  addReference: 'Add Reference',

  // Prayer Fields
  prayer: 'Prayer',
  prayerPart: 'Prayer Part',
  reciter: 'Reciter',
  reciters: 'Reciters',
  reference: 'Reference',
  text: 'Text',
  partIndex: 'Part Index',
  translations: 'Translations',
  partText: 'Part Text',
  partTranslations: 'Part Translations',
  localAlpha: 'Local Alphabetic',
  filterFields: 'Filter Visible Fields',
  selectFieldsToDisplay: 'Select which fields to display in prayer parts:',
  fieldsActive: 'fields active',

  // Prayer Tables
  prayersTable: 'Prayers Table',
  prayerPartsTable: 'Prayer Parts Table',
  prayerRecitersTable: 'Prayer Reciters Table',
  prayerReferencesTable: 'Prayer References Table',
  prayerCategoriesTable: 'Prayer Categories Table',

  // Prayer Status
  noPrayersFound: 'No prayers found',
  noPrayerPartsFound: 'No prayer parts found',
  noPrayerRecitersFound: 'No prayer reciters found',
  noPrayerReferencesFound: 'No prayer references found',
  noPrayerCategoriesFound: 'No prayer categories found',

  // Prayer Common
  noText: 'No text',
  noDescription: 'No description',
  noName: 'No name',
  rootCategory: 'Root Category',
  part: 'Part',

  // Prayer Edit Pages
  editPrayer: 'Edit Prayer',
  editPrayerPart: 'Edit Prayer Part',
  editPrayerCategory: 'Edit Prayer Category',
  addPrayerReciter: 'Add Prayer Reciter',
  createNewPrayerReciter: 'Create a new prayer reciter',
  editPrayerReciter: 'Edit Prayer Reciter',
  pleaseEnterReciterName: 'Please enter reciter name',
  editPrayerReference: 'Edit Prayer Reference',
  deletePrayer: 'Delete Prayer',
  
  // Prayer Detail Page
  prayerDetails: 'Prayer Details',
  errorLoadingPrayer: 'Error loading prayer',
  prayerNotFound: 'Prayer not found',
  backToList: 'Back to list',
  audioAvailable: 'Audio available',
  audioNotSupported: 'Your browser does not support audio playback',
  noTranslations: 'No translations available',

  // Prayer Edit Descriptions
  updatePrayerInformation: 'Update prayer information and translations',
  updatePrayerPartInformation: 'Update prayer part information',
  updatePrayerCategoryInformation: 'Update prayer category information',
  updatePrayerReciterInformation: 'Update prayer reciter information',
  updatePrayerReferenceInformation: 'Update prayer reference information',

  // Prayer Edit Fields
  prayerBasicDetails: 'Prayer basic details',
  selectPrayerCategories: 'Select prayer categories',
  prayerAudioFile: 'Prayer audio file',
  managePrayerParts: 'Manage prayer parts',
  selectPrayer: 'Select prayer',
  selectParentCategory: 'Select parent category',
  categoryOrderDescription: 'Display order of category',
  parentCategory: 'Parent Category',
  parentCategoryOptional: 'Leave empty to create a root category',
  cannotSetSelfAsParent: 'Cannot set category as its own parent',
  startTypingToSearch: 'Start typing to search categories',
  reciterName: 'Reciter Name',
  enterReciterName: 'Enter reciter name',
  autoGeneratedFromName: 'Auto-generated from name',
  reciterTranslations: 'Reciter translations',
  avatarDescription: 'Path to reciter profile image',
  referenceTitle: 'Reference Title',
  enterReferenceTitle: 'Enter reference title',
  enterThumbnailPath: 'Enter thumbnail path',
  thumbnailDescription: 'Small image displayed in lists',
  descriptionTranslations: 'Description translations',
  avatarPreview: 'Avatar Preview',
  uploadAvatar: 'Upload Avatar',
  avatarWillBeDisplayed: 'This image will be displayed in the reciters list',
  thumbnailPreview: 'Thumbnail Preview',
  thumbnailWillBeDisplayed: 'This image will be displayed in the references list',

  // Prayer Edit Actions
  makePrayerVisible: 'Make prayer visible',
  makePrayerPartVisible: 'Make prayer part visible',
  makeCategoryVisible: 'Make category visible',
  priorityDescription: 'Display priority in lists',

  // Special Files Actions
  addSpecialFile: 'Add Special File',
  editSpecialFile: 'Edit Special File',

  // Special Files Fields
  specialFile: 'Special File',
  specialFilesTable: 'Special Files Table',
  searchSpecialFiles: 'Search special files',
  multimediaItems: 'Multimedia Items',
  multimedia: 'Multimedia',
  articles: 'Articles',
  topics: 'Topics',
  media: 'Media',
  basicInformation: 'Basic Information',
  mediaFiles: 'Media Files',
  colorSettings: 'Color Settings',
  contentSections: 'Content Sections',
  booksSection: 'Books Section',
  multimediaSection: 'Multimedia Section',
  articlesSection: 'Articles Section',

  // Special Files Form Fields
  bookSectionTitle: 'Book Section Title',
  bookSectionDescription: 'Book Section Description',
  multimediaSectionTitle: 'Multimedia Section Title',
  multimediaSectionDescription: 'Multimedia Section Description',
  articleSectionTitle: 'Article Section Title',
  articleSectionDescription: 'Article Section Description',
  addTopic: 'Add Topic',
  topicTitle: 'Topic Title',
  topicDescription: 'Topic Description',
  enterTopicTitle: 'Enter topic title',
  enterTopicDescription: 'Enter topic description',
  topicTitleRequired: 'Topic title is required',
  primaryColor: 'Primary Color',
  secondaryColor: 'Secondary Color',
  accentColor: 'Accent Color',
  backgroundColor: 'Background Color',
  thumbnail: 'Thumbnail',
  backgroundImage: 'Background Image',
  video: 'Video',
  videoThumbnail: 'Video Thumbnail',
  specialFileThumbnailDescription: 'Main thumbnail image for the special file',
  backgroundImageDescription: 'Background image for the special file',
  videoDescription: 'Video content for the special file',
  videoThumbnailDescription: 'Thumbnail/poster image for the video',
  specialFileSlugDescription: 'Auto-generated URL slug',
  specialFileOrderDescription: 'Order for sorting special files',
  enterBookSectionTitle: 'Enter book section title',
  enterBookSectionDescription: 'Enter book section description',
  enterMultimediaSectionTitle: 'Enter multimedia section title',
  enterMultimediaSectionDescription: 'Enter multimedia section description',
  enterArticleSectionTitle: 'Enter article section title',
  enterArticleSectionDescription: 'Enter article section description',

  // Special Files Status
  noSpecialFilesFound: 'No special files found',

  // Special Files Edit
  updateSpecialFileInformation: 'Update special file information',

  // News
  newsCategories: 'News Categories',

  // News Actions
  addNews: 'Add News',
  editNews: 'Edit News',
  createNews: 'Create News',
  newsDetail: 'News Detail',
  viewNewsInformation: 'View news information and details',
  createNewNewsArticle: 'Create a new news article',

  // News Fields
  news: 'News',
  summary: 'Summary',
  publishDate: 'Publish Date',
  newsTable: 'News Table',
  newsBasicDetails: 'News basic details',
  newsFullContent: 'Full news content',
  publishing: 'Publishing',
  publishingSettings: 'Publishing settings',
  featured: 'Featured',
  suggested: 'Suggested',
  regular: 'Regular',
  markAsSuggested: 'Mark as suggested news',
  newsActiveDescription: 'Make this news article visible to users',

  // News Edit
  updateNewsInformation: 'Update news information and content',
  enterNewsTitle: 'Enter news title',
  enterNewsSummary: 'Enter news summary',
  enterNewsContent: 'Enter news content',
  summaryDescription: 'Brief description for display in lists',
  generatingContent: 'Generating improved content',
  clickToUpload: 'Click to upload',
  maxSize5MB: 'Max size: 5MB',
  pleaseSelectImage: 'Please select an image file',
  imageTooLarge: 'Image size must be less than 5MB',
  uploadFailed: 'Failed to upload image',
  titleRequired: 'Title is required',
  summaryRequired: 'Summary is required',
  languageRequired: 'Please select a language',
  saveFailed: 'Failed to save news',
  newsNotFound: 'News article not found',
  fullContentOfNews: 'Full content of the news article',
  autoGeneratedFromTitle: 'Auto-generated from title',
  slugDescription: 'URL-friendly version of title',

  // News Status
  noNewsFound: 'No news found',
  noNewsCategoriesFound: 'No news categories found',

  // News Preview
  preview: 'Preview',

  // Wiki Sub-sections
  wikiEntries: 'Wiki Articles',
  wikiCategories: 'Wiki Categories',
  wikiAuthors: 'Wiki Authors',
  wikiContents: 'Wiki Contents',

  // Wiki Actions
  addWikiEntry: 'Add Wiki Article',
  addWikiCategory: 'Add Wiki Category',
  addAuthor: 'Add Author',

  // Wiki Fields
  wikiEntry: 'Wiki Article',
  author: 'Author',
  biography: 'Biography',
  content: 'Content',
  unknownAuthor: 'Unknown Author',

  // Wiki Tables
  wikiTable: 'Wiki Articles Table',
  wikiCategoriesTable: 'Wiki Categories Table',
  authorsTable: 'Authors Table',
  wikiContentsTable: 'Wiki Contents Table',

  // Wiki Status
  noWikiFound: 'No wiki articles found',
  noCategoriesFound: 'No categories found',
  noCategories: 'No categories available',
  noAuthorsFound: 'No authors found',
  noWikiContentsFound: 'No wiki contents found',

  // Wiki Edit Pages
  editWikiEntry: 'Edit Wiki Article',
  editCategory: 'Edit Category',
  editAuthor: 'Edit Author',

  // Wiki Edit Descriptions
  updateWikiInformation: 'Update wiki article information and content',
  updateCategoryInformation: 'Update category information',
  updateAuthorInformation: 'Update author information',

  // Wiki Edit Fields
  wikiBasicDetails: 'Wiki article basic details',
  selectCategory: 'Select Category',
  selectAuthor: 'Select Author',
  wikiTitleDescription: 'Article title in different languages',
  wikiSummaryDescription: 'Article summary for display in lists',
  authorNameDescription: 'Author name in different languages',
  authorBioDescription: 'Author biography and background',
  categoryNameDescription: 'Category name in different languages',
  categoryDescriptionDescription: 'Category description',
  makeAuthorVisible: 'Make author visible',
  slugPreview: 'Slug Preview',
  supportedLanguages: 'Supported Languages',
  quickSelectLanguage: 'Select a language to add',
  allLanguagesAdded: 'All available languages have been added',

  library: 'Library',
  magazines: 'Magazines',
  gallery: 'Gallery & Multimedia',
  astanStructures: 'Astan Structures',
  newsSection: 'News',
  wiki: 'Wiki & Articles',
  heartTalk: 'Heart Talk',
  contactUs: 'Contact Us',
  
  // Chat
  chat: 'Chat',
  conversations: 'Conversations',
  organizations: 'Organizations',
  manageOrganizations: 'Manage chat topics and related agents',
  noOrganizationsFound: 'No organizations found',
  organizationCreatedSuccessfully: 'Organization created successfully',
  organizationUpdatedSuccessfully: 'Organization updated successfully',
  organizationDeletedSuccessfully: 'Organization deleted successfully',
  errorCreatingOrganization: 'Error creating organization',
  errorUpdatingOrganization: 'Error updating organization',
  errorDeletingOrganization: 'Error deleting organization',
  activeChats: 'active chats',
  reconnecting: 'Reconnecting...',
  connectionLost: 'Connection lost. Trying to reconnect.',
  connected: 'Connected',
  connectionRestored: 'Connection restored successfully',
  guest: 'Guest',
  noMessages: 'No messages yet',
  activeAs: 'Active as {{name}}',
  impersonationActive: 'Impersonation mode active',
  selectOrganization: 'Select an organization to start',
  addOrganization: 'Add Organization',
  editOrganization: 'Edit Organization',
  deleteOrganization: 'Delete Organization',
  confirmDeleteOrganization: 'Are you sure you want to delete this organization?',
  organizationName: 'Organization Name',
  organizationDescription: 'Organization Description',
  searchPlaceholder: 'Type a command or search...',
  noResults: 'No results found.',
  navigate: 'to navigate',
  closeKey: 'to close',
  userManagement: 'User Management',
  portalSectionsMenu: 'Portal Sections',
  searchMessages: 'Search messages',
  dateFrom: 'From date',
  dateTo: 'To date',
  messagePlaceholder: 'Type a message...',
  noOrganizationSelected: 'No organization selected',
  lastMessage: 'Last message',
  selectConversation: 'Select a conversation to view details',
  contactInfo: 'Contact Information',
  location: 'Location',
  personalInfo: 'Personal Information',
  gender: 'Gender',
  male: 'Male',
  female: 'Female',
  birthdate: 'Birthdate',
  conversationId: 'Conversation ID',
  totalMessages: 'Total Messages',
  accountActivity: 'Account Activity',
  joinedAt: 'Joined',
  lastLogin: 'Last Login',
  clear: 'Clear',
  filters: 'Filters',
  allOrganizations: 'All Organizations',
  organizationDetails: 'Organization Details',
  userDetails: 'User Details',
  changesSaved: 'Changes saved',
  deleted: 'Deleted successfully',
  name: 'Name',
  roomDetails: 'Room Details',
  userInfo: 'User Information',
  roomInfo: 'Room Information',
  ipAddress: 'IP Address',
  roomId: 'Room ID',

  // Dashboard
  overview: 'Overview',
  today: 'Today',
  thisWeek: 'This Week',
  thisMonth: 'This Month',
  thisYear: 'This Year',
  exportReport: 'Export Report',
  exporting: 'Exporting...',
  reportExportedSuccessfully: 'Report exported successfully',
  failedToExportReport: 'Failed to export report',
  totalVisits: 'Total Visits',
  totalUsers: 'Total Users',
  activeUsers: 'Active Users',
  newUsers: 'New Users',
  totalContent: 'Total Content',
  averageSessionTime: 'Average Session Time',
  bounceRate: 'Bounce Rate',
  visitsOverTime: 'Visits Over Time',
  detailed: 'Detailed',
  topCountries: 'Top Countries',
  topLanguages: 'Top Languages',
  visits: 'Visits',
  mostViewedPages: 'Most Viewed Pages',
  page: 'Page',
  views: 'Views',
  aiChatInteractions: 'AI Chat Interactions',
  wikiArticles: 'Wiki Articles',
  galleryItems: 'Gallery Items',
  frequentlyAskedQuestions: 'Frequently Asked Questions',
  question: 'Question',
  category: 'Category',
  frequency: 'Frequency',
  lastAsked: 'Last Asked',
  
  // Profile
  profile: 'Profile',
  profileSettings: 'Settings',
  updateYourPersonalInformation: 'Update your personal information',
  profilePicture: 'Profile Picture',
  uploadPhoto: 'Upload Photo',
  allowedFormats: 'Allowed formats',
  maxSize: 'Maximum size',
  personalInformation: 'Personal Information',
  locationInformation: 'Location Information',
  fullName: 'Full Name',
  enterFullName: 'Enter your full name',
  enterEmail: 'Enter your email',
  enterPhoneNumber: 'Enter your phone number',
  selectGender: 'Select gender',
  selectLanguage: 'Select language',
  enterCity: 'Enter your city',
  enterCountry: 'Enter your country',
  maleGender: 'Male',
  femaleGender: 'Female',
  persianLang: 'Persian',
  englishLang: 'English',
  arabicLang: 'Arabic',
  saveChanges: 'Save Changes',
  profileUpdatedSuccessfully: 'Profile updated successfully',
  errorUpdatingProfile: 'Error updating profile',
  errorUploadingAvatar: 'Error uploading profile picture',
  fullnameRequired: 'Full name is required',
  emailRequired: 'Email is required',
  emailAlreadyExists: 'This email already exists',
  fullnameInvalid: 'Full name is invalid',
  help: 'Help',
  
  // Language
  language: 'Language',
  english: 'English',
  persian: 'Persian',
  arabic: 'Arabic',
  
  // Library - Books
  books: 'Books',
  book: 'Book',
  addBook: 'Add Book',
  addNewBook: 'Add New Book',
  editBook: 'Edit Book',
  updateBookInformation: 'Update book information and translations',
  bookNotFound: 'Book Not Found',
  bookLoadError: 'Failed to load book information',
  backToBooks: 'Back to Books',
  booksTable: 'Books Table',
  noBooksFound: 'No books found',
  loading: 'Loading...',

  // Library Sub-modules (using existing translations)
  // authors: 'Authors', (already defined in Book Fields)
  // publishers: 'Publishers', (already defined in Book Fields)
  // categories: 'Categories', (already defined in Book Fields)
  // bookFiles: 'Book Files', (already defined in Book Files)

  // Library Common
  totalItems: 'Total {{count}} items',
  recentActivity: 'Recent Activity',
  newBookAdded: 'New book added',
  bookUpdated: 'Book updated',
  newFileAdded: 'New file added',
  hoursAgo: 'hours ago',
  dayAgo: 'day ago',
  
  // Book Fields
  bookTitle: 'Title',
  bookSlug: 'Slug',
  isbn: 'ISBN',
  rating: 'Rating',
  bookDescription: 'Description',
  bookSummary: 'Summary',
  bookPublisher: 'Publisher',
  bookPublishDate: 'Publish Date',
  bookAuthors: 'Authors',
  selectAuthors: 'Select authors',
  bookCategories: 'Categories',
  selectCategories: 'Select categories',
  searchCategories: 'Search categories...',
  loadingCategories: 'Loading categories...',
  loadingMore: 'Loading more...',
  tryDifferentSearch: 'Try a different search term',
  tryDifferentKeywords: 'Try different keywords',
  clearSelection: 'Clear selection',
  errorLoadingCategories: 'Error loading categories',
  noCategoriesAvailable: 'No categories available',
  noResultsFound: 'No results found',
  of: 'of',
  addMoreCategories: 'Add more categories',
  category: 'Category',
  pleaseEnterTitle: 'Please enter a title',
  pleaseSelectCategory: 'Please select at least one category',
  creatingPrayer: 'Creating prayer...',
  updatingPrayer: 'Updating prayer...',
  prayerCreatedSuccessfully: 'Prayer created successfully',
  prayerUpdatedSuccessfully: 'Prayer updated successfully',
  errorCreatingPrayer: 'Error creating prayer',
  errorUpdatingPrayer: 'Error updating prayer',
  reciter: 'Reciter',
  selectReciter: 'Select reciter',
  uploadAudio: 'Upload audio',
  changeAudio: 'Change audio',
  uploading: 'Uploading...',
  audioUploadedSuccessfully: 'Audio uploaded successfully',
  errorUploadingAudio: 'Error uploading audio',
  noAudioFiles: 'No audio files',
  addAudio: 'Add audio',
  audioFiles: 'Audio files',
  managePrayerAudioFiles: 'Manage prayer audio files',
  searchReciters: 'Search reciters...',
  noRecitersFound: 'No reciters found',
  noRecitersAvailable: 'No reciters available',
  loadMore: 'Load more',
  searchParts: 'Search parts...',
  remaining: 'remaining',
  more: 'more',
  selectLanguages: 'Select languages',
  status: 'Status',
  entryIsActive: 'This entry is active',
  entryIsInactive: 'This entry is inactive',
  order: 'Order',
  enterOrder: 'Enter display order',
  orderDescription: 'Display order for sorting',
  published: 'Published',
  draft: 'Draft',
  viewCount: 'View Count',
  createdAt: 'Created At',
  updatedAt: 'Updated At',
  bookCover: 'Book Cover',
  displayOrder: 'Display Order',
  
  // Translations
  bookTranslations: 'Translations',
  multilingualContent: 'Multilingual content and translations',
  bookSupportedLanguages: 'Supported Languages',
  bookAddLanguage: 'Add Language',
  bookQuickSelectLanguage: 'Select a language to add',
  bookAllLanguagesAdded: 'All available languages have been added',
  titleTranslations: 'Title Translations',
  bookDescriptionTranslations: 'Description Translations',
  summaryTranslations: 'Summary Translations',
  close: 'Close',
  
  // Sections
  bookBasicDetails: 'Title, ISBN, and basic details',
  contentDescriptions: 'Content & Descriptions',
  bookContentDetails: 'Summary and detailed descriptions',
  authorsPublisher: 'Authors & Publisher',
  selectAuthorsAndPublisher: 'Select book authors and publisher',
  bookCategoriesSection: 'Book categories and classification',
  productDetails: 'Product Details',
  additionalProductInformation: 'Additional product specifications',
  metadata: 'Metadata',
  
  // Placeholders & Descriptions
  enterBookTitle: 'Enter book title',
  autoGeneratedFromTitle: 'Auto-generated from title',
  bookSlugDescription: 'URL-friendly identifier for the book',
  briefSummary: 'A brief summary of the book',
  bookSummaryDescription: 'Short overview shown in listings',
  detailedDescription: 'Detailed description of the book',
  bookDescriptionDescription: 'Full description shown on book page',
  selectPublisher: 'Select a publisher',
  bookOrderDescription: 'Lower numbers appear first',
  makeBookVisible: 'Make this book visible to users',
  
  // Product Details
  detailTitle: 'Detail Title',
  detailValue: 'Detail Value',
  addDetail: 'Add Detail',
  
  // Book Files
  bookFiles: 'Book Files',
  uploadAndManageBookFiles: 'Upload and manage book files in different formats',
  noFilesAdded: 'No files added yet',
  addFirstFile: 'Add First File',
  file: 'File',
  primary: 'Primary',
  fileUploaded: 'File uploaded',
  uploadFile: 'Upload File',
  change: 'Change',
  versionNumber: 'Version Number',
  versionType: 'Version Type',
  original: 'Original',
  pageCount: 'Page Count',
  fileFormat: 'File Format',
  setPrimaryFile: 'Set as primary file',
  addAnotherFile: 'Add Another File',
  generatingDescription: 'Generating description based on book information',
  noImageSelected: 'No image selected',
  
  // Actions
  cancel: 'Cancel',
  saveChanges: 'Save Changes',
  uploadImage: 'Upload Image',
  changeImage: 'Change Image',
  
  // Common
  more: 'more',
  back: 'Back',
  edit: 'Edit',
  
  // Users & Permissions
  addUser: 'Add User',
  editUser: 'Edit User',
  userDetails: 'User Details',
  userNotFound: 'User not found',
  backToUsers: 'Back to Users',
  username: 'Username',
  phoneNumber: 'Phone Number',
  city: 'City',
  country: 'Country',
  role: 'Role',
  admin: 'Admin',
  editor: 'Editor',
  viewer: 'Viewer',
  active: 'Active',
  inactive: 'Inactive',
  permissionGroups: 'Permission Groups',
  individualPermissions: 'Individual Permissions',
  noPermissionGroups: 'No permission groups assigned',
  activityInformation: 'Activity Information',
  memberSince: 'Member Since',
  managePermissions: 'Manage Permissions',
  usersTable: 'Users Table',
  noUsersFound: 'No users found',
  activeUserDescription: 'Active users can login and access the system',
  addPermission: 'Add Permission',
  addPermissionGroup: 'Add Permission Group',
  permissions: 'Permissions',
  searchPermissions: 'Search permissions...',
  searchPermissionGroups: 'Search permission groups...',
  permissionsTable: 'Permissions Table',
  permissionGroupsTable: 'Permission Groups Table',
  noPermissionsFound: 'No permissions found',
  noPermissionGroupsFound: 'No permission groups found',
  module: 'Module',
  type: 'Type',
  view: 'View',
  add: 'Add',
  delete: 'Delete',
  selectedPermissions: 'Selected Permissions',
  clearAll: 'Clear All',
  noPermissionsSelected: 'No permissions selected',

  // Toast Messages
  toastMessages: {
    // Network & API Errors - Admin-friendly messages
    networkError: 'Unable to reach server',
    networkErrorDetail: 'Check your internet connection. If issue persists, contact technical team',
    
    serverError: 'Server error',
    serverErrorDetail: 'Server encountered an error. Technical team has been notified',
    serverErrorDetailWithRetry: 'Server temporarily unavailable. Please wait a few minutes and try again',
    
    serverDown: 'Server unavailable',
    serverDownDetail: 'Server is currently not responding. Contact technical team or try again in a few minutes',
    
    serverTimeout: 'Request timed out',
    serverTimeoutDetail: 'Server is taking longer than usual to respond. Server may be busy',
    
    unauthorizedError: 'Session expired',
    unauthorizedErrorDetail: 'Your session has expired. Please log in again',
    
    forbiddenError: 'Access denied',
    forbiddenErrorDetail: 'You do not have permission for this operation. Contact system administrator',
    
    notFoundError: 'Content not found',
    notFoundErrorDetail: 'The requested information does not exist or has been deleted',
    
    validationError: 'Invalid data',
    validationErrorDetail: 'Some fields are invalid. Please review the form',
    
    conflictError: 'Data conflict',
    conflictErrorDetail: 'This data already exists or conflicts with existing data',
    
    tooManyRequestsError: 'Too many requests',
    tooManyRequestsErrorDetail: 'You have exceeded the request limit. Please wait a moment',
    
    badGatewayError: 'Server communication error',
    badGatewayErrorDetail: 'Server could not communicate with backend services',
    
    serviceUnavailableError: 'Service temporarily unavailable',
    serviceUnavailableErrorDetail: 'Service is under maintenance. Please try again in a few minutes',
    
    unknownError: 'Unexpected error',
    unknownErrorDetail: 'An unknown error occurred. Please contact technical team',
    
    // Books
    bookCreatedSuccess: 'Book created successfully',
    bookCreatedError: 'Error creating book',
    bookUpdatedSuccess: 'Book updated successfully',
    bookUpdatedError: 'Error updating book',
    bookDeletedSuccess: 'Book deleted successfully',
    bookDeletedError: 'Error deleting book',
    
    // News
    newsCreatedSuccess: 'News article created successfully',
    newsCreatedError: 'Error creating news article',
    newsUpdatedSuccess: 'News article updated successfully',
    newsUpdatedError: 'Error updating news article',
    newsDeletedSuccess: 'News article deleted successfully',
    newsDeletedError: 'Error deleting news article',
    
    // Reciters
    reciterCreatedSuccess: 'Reciter created successfully',
    reciterCreatedError: 'Error creating reciter',
    reciterUpdatedSuccess: 'Reciter updated successfully',
    reciterUpdatedError: 'Error updating reciter',
    reciterDeletedSuccess: 'Reciter deleted successfully',
    reciterDeletedError: 'Error deleting reciter',
    
    // Login & Auth
    loginSuccess: 'Login successful',
    loginError: 'Login error. Please try again.',
    captchaRequired: 'Please complete the captcha verification',
    
    // Generic
    savedSuccess: 'Changes saved successfully',
    savedError: 'Error saving changes',
    deletedSuccess: 'Deleted successfully',
    deletedError: 'Error deleting',
    allPermissions: 'All Permissions',
    youHaveFullAccess: 'You have full access to all features',
    
    // File Upload (toast messages)
    fileUploadSuccess: 'File uploaded successfully',
    fileUploadError: 'Error uploading file',
    uploading: 'Uploading...',
    fileTooLarge: 'File size must be less than {{max}}',
    pleaseSelectImageFile: 'Please select an image file',
    fileUploadedSuccessfully: 'File uploaded successfully',
    
    createdSuccess: 'Created successfully',
    createdError: 'Error creating',
    updatedSuccess: 'Updated successfully',
    updatedError: 'Error updating',
  },

  // 404 Page
  pageNotFound: 'Page Not Found',
  pageNotFoundMessage: 'The page you are looking for does not exist or has been moved.',
  backToDashboard: 'Back to Dashboard',

  // Page Titles
  pageTitles: {
    dashboard: 'Dashboard',
    login: 'Login',
    users: 'Users & Permissions',
    createUser: 'Create New User',
    userDetail: 'User Details',
    editUser: 'Edit User',
    userPermissions: 'User Permissions',
    permissions: 'Permissions Management',
    createPermission: 'Create New Permission',
    editPermission: 'Edit Permission',
    createPermissionGroup: 'Create Permission Group',
    editPermissionGroup: 'Edit Permission Group',
    technicalSupport: 'Technical Support',
    settings: 'Settings',
    statistics: 'Statistics & Reports',
    chatConversations: 'Conversations',
    chatOrganizations: 'Chat Organizations',
    imamIntro: "Imam's Biography",
    hadiths: 'Hadith Subcategories',
    hadithsList: 'Hadith Subcategories List',
    createHadith: 'Create New Hadith Subcategory',
    editHadith: 'Edit Hadith Subcategory',
    addHadith: 'Add Hadith Subcategory',
    hadithsCategories: 'Main Categories',
    hadithsNarrators: 'Hadith Narrators',
    createHadithNarrator: 'Create Hadith Narrator',
    editHadithNarrator: 'Edit Hadith Narrator',
    hadithNarratorDetails: 'Hadith Narrator Details',
    hadithsReferences: 'Hadith References',
    createHadithReference: 'Create Hadith Reference',
    editHadithReference: 'Edit Hadith Reference',
    hadithReferenceDetails: 'Hadith Reference Details',
    hadithsParts: 'Hadiths',
    prayers: 'Prayers & Visitations',
    prayersList: 'Prayers List',
    createPrayer: 'Create Prayer',
    editPrayer: 'Edit Prayer',
    prayersCategories: 'Prayer Categories',
    createPrayerCategory: 'Create Prayer Category',
    editPrayerCategory: 'Edit Prayer Category',
    prayersNarrators: 'Prayer Reciters',
    createPrayerNarrator: 'Create Reciter',
    editPrayerNarrator: 'Edit Reciter',
    prayersReferences: 'Prayer References',
    createPrayerReference: 'Create Prayer Reference',
    editPrayerReference: 'Edit Prayer Reference',
    prayersParts: 'Prayer Parts',
    createPrayerPart: 'Create Prayer Part',
    editPrayerPart: 'Edit Prayer Part',
    noCategory: 'No Category',
    categoryPath: 'Category Path',
    library: 'Library',
    books: 'Books',
    editBook: 'Edit Book',
    authors: 'Authors',
    editAuthor: 'Edit Author',
    publishers: 'Publishers',
    createPublisher: 'Create Publisher',
    editPublisher: 'Edit Publisher',
    categories: 'Book Categories',
    createCategory: 'Create Category',
    editCategory: 'Edit Category',
    categoryDetails: 'Category Details',
    categoryNotFound: 'Category not found',
    backToCategories: 'Back to Categories',
    deleteCategoryConfirmation: 'Are you sure you want to delete this category?',
    categoryHasBooks: 'This category has {{count}} books.',
    booksCount: 'Books Count',
    noCategoriesFound: 'No categories found',
    searchCategories: 'Search categories',
    categoriesTable: 'Categories Table',
    categoryTitle: 'Category Title',
    categoryTitleDescription: 'Category title in different languages',
    updateCategoryInformation: 'Update category information',
    makeCategoryVisible: 'Make category visible',
    bookFiles: 'Book Files',
    magazines: 'Magazines',
    magazinesList: 'Magazines List',
    createMagazine: 'Create Magazine',
    editMagazine: 'Edit Magazine',
    gallery: 'Gallery & Multimedia',
    media: 'Media',
    createMedia: 'Add Media',
    editMedia: 'Edit Media',
    mediaCategories: 'Media Categories',
    createMediaCategory: 'Create Media Category',
    editMediaCategory: 'Edit Media Category',
    news: 'News',
    newsList: 'News List',
    createNews: 'Create News',
    editNews: 'Edit News',
    newsCategories: 'News Categories',
    specialFiles: 'Special Files',
    specialFilesList: 'Special Files List',
    createSpecialFile: 'Create Special File',
    editSpecialFile: 'Edit Special File',
    wiki: 'Wiki & Articles',
    wikiList: 'Articles List',
    createWiki: 'Create Article',
    editWiki: 'Edit Article',
    wikiCategories: 'Wiki Categories',
    createWikiCategory: 'Create Wiki Category',
    editWikiCategory: 'Edit Wiki Category',
    wikiAuthors: 'Wiki Authors',
    createWikiAuthor: 'Create Author',
    editWikiAuthor: 'Edit Author',
    wikiContents: 'Wiki Contents',
    heartTalk: 'Heart Talk',
    heartTalkList: 'Heart Talk List',
    heartTalkCategories: 'Heart Talk Categories',
    heartTalkAuthors: 'Heart Talk Speakers',
    createHeartTalkAuthor: 'Create Speaker',
    editHeartTalkAuthor: 'Edit Speaker',
    contactUs: 'Contact Us',
  },

  // Keep old keys for backward compatibility
  dashboard: 'Dashboard',
  login: 'Login',
  users: 'Users & Permissions',
  createUser: 'Create New User',
  userDetail: 'User Details',
  editUser: 'Edit User',
  userPermissions: 'User Permissions',
  permissions: 'Permissions Management',
  createPermission: 'Create New Permission',
  editPermission: 'Edit Permission',
  createPermissionGroup: 'Create Permission Group',
  editPermissionGroup: 'Edit Permission Group',
  technicalSupport: 'Technical Support',
  settings: 'Settings',
  statistics: 'Statistics & Reports',
  chatConversations: 'Conversations',
  chatOrganizations: 'Chat Organizations',
  imamIntro: "Imam's Biography",
  hadiths: 'Hadith Subcategories',
  hadithsList: 'Hadith Subcategories List',
  createHadith: 'Create New Hadith Subcategory',
  editHadith: 'Edit Hadith Subcategory',
  addHadith: 'Add Hadith Subcategory',
  hadithsCategories: 'Main Categories',
  hadithsNarrators: 'Hadith Narrators',
  hadithsReferences: 'Hadith References',
  hadithsParts: 'Hadiths',
  prayers: 'Prayers & Visitations',
  prayersList: 'Prayers List',
  createPrayer: 'Create Prayer',
  editPrayer: 'Edit Prayer',
  prayersCategories: 'Prayer Categories',
  createPrayerCategory: 'Create Prayer Category',
  editPrayerCategory: 'Edit Prayer Category',
  prayersNarrators: 'Prayer Reciters',
  createPrayerNarrator: 'Create Reciter',
  editPrayerNarrator: 'Edit Reciter',
  prayersReferences: 'Prayer References',
  createPrayerReference: 'Create Prayer Reference',
  editPrayerReference: 'Edit Prayer Reference',
  prayersParts: 'Prayer Parts',
  createPrayerPart: 'Create Prayer Part',
  editPrayerPart: 'Edit Prayer Part',
  noCategory: 'No Category',
  categoryPath: 'Category Path',
  library: 'Library',
  books: 'Books',
  editBook: 'Edit Book',
  authors: 'Authors',
  editAuthor: 'Edit Author',
  publishers: 'Publishers',
  createPublisher: 'Create Publisher',
  editPublisher: 'Edit Publisher',
  categories: 'Book Categories',
  createCategory: 'Create Category',
  editCategory: 'Edit Category',
  categoryDetails: 'Category Details',
  categoryNotFound: 'Category not found',
  backToCategories: 'Back to Categories',
  deleteCategoryConfirmation: 'Are you sure you want to delete this category?',
  categoryHasBooks: 'This category has {{count}} books.',
  booksCount: 'Books Count',
  noCategoriesFound: 'No categories found',
  searchCategories: 'Search categories',
  categoriesTable: 'Categories Table',
  categoryTitle: 'Category Title',
  categoryTitleDescription: 'Category title in different languages',
  updateCategoryInformation: 'Update category information',
  makeCategoryVisible: 'Make category visible',
  bookFiles: 'Book Files',
  magazines: 'Magazines',
  magazinesList: 'Magazines List',
  createMagazine: 'Create Magazine',
  editMagazine: 'Edit Magazine',
  gallery: 'Gallery & Multimedia',
  media: 'Media',
  createMedia: 'Add Media',
  editMedia: 'Edit Media',
  mediaCategories: 'Media Categories',
  createMediaCategory: 'Create Media Category',
  editMediaCategory: 'Edit Media Category',
  news: 'News',
  newsList: 'News List',
  createNews: 'Create News',
  editNews: 'Edit News',
  newsCategories: 'News Categories',
  specialFiles: 'Special Files',
  specialFilesList: 'Special Files List',
  createSpecialFile: 'Create Special File',
  editSpecialFile: 'Edit Special File',
  wiki: 'Wiki & Articles',
  wikiList: 'Articles List',
  createWiki: 'Create Article',
  editWiki: 'Edit Article',
  wikiCategories: 'Wiki Categories',
  createWikiCategory: 'Create Wiki Category',
  editWikiCategory: 'Edit Wiki Category',
  wikiAuthors: 'Wiki Authors',
  createWikiAuthor: 'Create Author',
  editWikiAuthor: 'Edit Author',
  wikiContents: 'Wiki Contents',
  heartTalk: 'Heart Talk',
  heartTalkList: 'Heart Talk List',
  heartTalkCategories: 'Heart Talk Categories',
  heartTalkAuthors: 'Heart Talk Speakers',
  createHeartTalkAuthor: 'Create Speaker',
  editHeartTalkAuthor: 'Edit Speaker',
  contactUs: 'Contact Us',

  // Biography/Imam Intro
  timeline: 'Timeline',
  dragToReorder: 'Drag to reorder',
  biographyImage: 'Biography Image',
  changeImage: 'Change Image',
  remove: 'Remove',
  dragDropOrClick: 'Drag & drop or click to upload',
  noImageAvailable: 'No image available',
  supportedFormats: 'Supported formats',
  clickImageToChange: 'Click image to change',
  uploadImage: 'Upload Image',
  yearRequired: 'Year is required',
  titleRequired: 'At least one title translation is required',
  descriptionRequired: 'At least one description translation is required',
  imageRequired: 'Biography image is required',
  supportedLanguages: 'Supported Languages',
  addLanguage: 'Add Language',
  selectBiographyFromTimeline: 'Select a biography entry from the timeline above',
  editBiography: 'Edit Biography',
  biographyDetails: 'Biography Details',
  newBiography: 'New Biography',
  year: 'Year',
  enterYear: 'Enter year (e.g., 148)',
  yearDescription: 'Year of the event in Hijri calendar',
  title: 'Title',
  description: 'Description',
  visibility: 'Visibility',
  visibilityDescription: 'Show this entry to users',
  isActive: 'Active',
  created: 'Created',
  updated: 'Updated',
  actions: 'Actions',
  manageBiographyEntries: 'Manage biography entries and timeline',
  editMode: 'Edit Mode',
  addNew: 'Add New',
  save: 'Save',
  deleteConfirmationMessage: 'Are you sure you want to delete this biography entry? This action cannot be undone.',
  errorLoadingBiographies: 'Error loading biographies. Please try again.',
  enterTranslationIn: 'Enter translation in',
  aiAnalyzing: 'AI Analyzing...',
  generatingTranslation: 'Generating translation',
  noTitle: 'No title',
  
  // Hadiths Section (sidebar)
  hadisCategories: 'Main Categories',
  narrators: 'Narrators',
  references: 'References',
  hadisParts: 'Hadiths',

  // Hadiths / Hadis Parts - selectors & combobox states
  selectHadith: 'Select Hadith Subcategory',
  searchHadiths: 'Search Hadith Subcategories...',
  searchNarrators: 'Search narrators...',
  searchReferences: 'Search references...',
  noHadithSelected: 'No Hadith Subcategory selected',
  noNarratorSelected: 'No narrator selected',
  narratorId: 'Narrator ID',
  enterNarratorId: 'Enter narrator ID',
  pleaseEnterText: 'Please enter the text',
  pleaseSelectHadith: 'Please select a Hadith Subcategory',
  hadisPartNotFound: 'Hadith not found.',
  hadisPart: 'Hadith',
  addHadisPart: 'Add Hadith',
  createHadisPart: 'Create Hadith',
  editHadisPart: 'Edit Hadith',
  hadisPartDetails: 'Hadith Details',
  createNewHadisPart: 'Create a new hadith',
  viewHadisPartInformation: 'View hadith information',
  updateHadisPartInformation: 'Update hadith information',
  hadisPartCreatedSuccessfully: 'Hadith created successfully',
  hadisPartUpdatedSuccessfully: 'Hadith updated successfully',
  hadisPartDeletedSuccessfully: 'Hadith deleted successfully',
  errorCreatingHadisPart: 'Error creating hadith',
  errorUpdatingHadisPart: 'Error updating hadith',
  errorDeletingHadisPart: 'Error deleting hadith',
  hadisPartVisibility: 'Hadith visibility',
  unnamed: 'Unnamed',
  searchPlaceholder: 'Search...',

  // Hadith narrators and references management
  addNarrator: 'Add Narrator',
  editNarrator: 'Edit Narrator',
  narratorDetails: 'Narrator Details',
  narratorName: 'Base Narrator Name',
  narratorNameTranslations: 'Narrator Name Translations',
  enterNarratorTranslation: 'Enter the translated narrator name',
  createNewNarrator: 'Create a new narrator',
  updateNarratorInformation: 'Update narrator information',
  backToNarrators: 'Back to narrators',
  baseName: 'Base Name',
  narratorsTable: 'Narrators Table',
  noNarratorsFound: 'No narrators found',
  errorLoadingNarrators: 'Failed to load narrators',
  errorLoadingNarrator: 'Failed to load narrator',
  narratorNameRequired: 'The base narrator name is required',
  narratorCreatedSuccessfully: 'Narrator created successfully',
  narratorUpdatedSuccessfully: 'Narrator updated successfully',
  narratorDeletedSuccessfully: 'Narrator deleted successfully',
  errorCreatingNarrator: 'Failed to create narrator',
  errorUpdatingNarrator: 'Failed to update narrator',
  errorDeletingNarrator: 'Failed to delete narrator',
  deleteNarratorConfirmation: 'Are you sure you want to delete "{{name}}"?',
  editReference: 'Edit Reference',
  referenceDetails: 'Reference Details',
  createNewReference: 'Create a new reference',
  updateReferenceInformation: 'Update reference information',
  backToReferences: 'Back to references',
  baseTitle: 'Base Title',
  referencesTable: 'References Table',
  noReferencesFound: 'No references found',
  errorLoadingReferences: 'Failed to load references',
  errorLoadingReference: 'Failed to load reference',
  referenceTitleRequired: 'The base reference title is required',
  enterReferenceTranslation: 'Enter the translated reference title',
  enterReferenceDescription: 'Enter the reference description',
  referenceCreatedSuccessfully: 'Reference created successfully',
  referenceUpdatedSuccessfully: 'Reference updated successfully',
  referenceDeletedSuccessfully: 'Reference deleted successfully',
  errorCreatingReference: 'Failed to create reference',
  errorUpdatingReference: 'Failed to update reference',
  errorDeletingReference: 'Failed to delete reference',
  deleteReferenceConfirmation: 'Are you sure you want to delete "{{title}}"?',
  pleaseAddAtLeastOneTranslation: 'Enter at least one valid translation',
  totalCount: 'Total',
  changeSortOrder: 'Change sort direction',
  selectImage: 'Select Image',
  removeImage: 'Remove Image',
  invalidImageFormat: 'The selected file is not a valid image',
  thumbnailUploadHint: 'Optional image, up to 5 MB',
  
  // Heart Talk Section (sidebar)
  heartTalks: 'Heart Talks',
  heartTalkSpeakers: 'Speakers',
};
